'use client';

import { MouseEvent } from 'react';
import { useRouter } from 'next/navigation';
import { SearchViewModel } from '@/types/api';
import { cn } from '@/utils/cn';
import { MIN_ACCEPTABLE_QUERY_LENGTH } from './constants';
import LastSearchHistory from './last-search-history';
import SearchboxBanner from './searbhbox-banner';
import SearchResultChips from './search-result-chips';
import SearchResultProducts from './search-result-products';
import Suggestions from './suggestions';
import { useSearchModal } from './context/search-modal-context';
import { useCategoryModal } from '../category-modal/context/category-modal-context';
import SearchSkeleton from '../components/search-skeleton';
interface SearchResultsProps {
  isFetching: boolean;
  query: string;
  noResult: boolean;
  isError: boolean;
  results: SearchViewModel | null;
  isOpen: boolean;
  variant?: 'desktop' | 'mobile';
}
function SearchResults({
  isFetching,
  query,
  noResult,
  isError,
  results,
  isOpen,
  variant = 'desktop'
}: SearchResultsProps) {
  const {
    close: closeCategoryModal,
    isOpen: isCategoryModalOpen
  } = useCategoryModal();
  const {
    close: closeSearchModal,
    isOpen: isSearchModalOpen
  } = useSearchModal();
  const router = useRouter();
  const isMobile = variant === 'mobile';
  if (isFetching && query.length) {
    return <SearchSkeleton className='mt-2' />;
  }
  const handleClickItem = (e: MouseEvent, href: string) => {
    e.preventDefault();
    if (isCategoryModalOpen && isSearchModalOpen) {
      history.go(-1);
    }
    closeCategoryModal();
    closeSearchModal();
    setTimeout(() => {
      router.replace(href);
    });
  };
  return <>
            <span data-test='search-result--empty' className={cn(isMobile ? 'mb-4 text-body-14' : 'mb-7 px-1 text-body-16', 'block text-text-mediumGray', query.length > MIN_ACCEPTABLE_QUERY_LENGTH && noResult && !isError ? 'block' : 'hidden')}>
                برای جست‌وجوی شما نتیجه‌ای پیدا نشد!
            </span>

            {isError && query.length ? <span data-test='search-result--error' className={cn('mb-2 block', isMobile ? 'text-body-14' : 'px-4 text-body-16')}>
                    جست‌وجو با خطا مواجه شد.
                </span> : null}

            {!isError && <>
                    {isMobile && noResult && <SearchboxBanner className='mb-5' handleClickItem={handleClickItem} />}

                    {results?.categories && <SearchResultChips dataTest='categories' items={results.categories} title='دسته‌بندی‌ها' handleClickItem={handleClickItem} />}

                    {results?.brands && <SearchResultChips dataTest='brands' items={results.brands} title='برندها' handleClickItem={handleClickItem} />}

                    {noResult && <LastSearchHistory handleClickItem={handleClickItem} />}

                    <Suggestions items={results?.popularSearch || []} title='جست‌وجوهای پرطرفدار' handleClickItem={handleClickItem} />

                    <SearchResultProducts query={query} items={results?.products || null} title='محصولات' isModalOpen={isOpen} handleClickItem={handleClickItem} />

                    {!isMobile && noResult && <SearchboxBanner className='mt-5' handleClickItem={handleClickItem} />}
                </>}
        </>;
}
export default SearchResults;